import { useEffect } from 'react';

const SITE_NAME = 'Fundviser Capital (India) Ltd';
const DEFAULT_TITLE = 'Fundviser Capital (India) Ltd. | BSE-Listed Investment Company';
const DEFAULT_DESCRIPTION = "Fundviser Capital (India) Ltd. is a Mumbai-based, BSE-listed (530197) investment company deploying capital across real estate, equities, bullion, and startup ventures since 1993.";

export default function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE;

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description || DEFAULT_DESCRIPTION);
    }
  }, [title, description]);
}
